/* eslint-disable no-empty-pattern */
/* eslint-disable react/display-name */
import { useState, useCallback, useEffect } from 'react';
import TestType from '../testType';
import {
	Accordion,
	AccordionItem,
	AccordionItemHeading,
	AccordionItemButton,
	AccordionItemPanel,
} from 'react-accessible-accordion';
import PropTypes from 'prop-types';
import Loader from 'react-spinners/BarLoader';
import { fetchApiProducts } from '../../utils/helpers';

const TestingDetailsContent = ({ rows }) => {
	const [activeIndex, setActiveIndex] = useState(null);
	const [isLoading, setIsLoading] = useState(false);
	const [productInfo, setProductInfo] = useState([]);
	const handleAccordionChange = useCallback(
		(index) => () => {
			setActiveIndex(index === activeIndex ? null : index);
		},
		[setActiveIndex]
	);

	const fetchProducts= () =>{
		setIsLoading(true);
		const products  = fetchApiProducts(rows);
		products.then((values) => {
			setProductInfo(values);
			setIsLoading(false);
		})
			.catch((error) => {
				setIsLoading(false);
				console.error(error.message);
			});
	};


	useEffect(() => {
		fetchProducts();
	}, []);


	if (isLoading) return <Loader isLoading={isLoading} />;
	if (!productInfo) return null;

	return rows.length > 1 ? (
		<div className="testing-details-individuals">
			<Accordion
				className="testing-details-individuals__accordion accordion"
				allowZeroExpanded={true}
			>
				{rows.map((acc, index) => {
					const { title, tests } = acc;
					return (
						<AccordionItem
							className="testing-details-individuals__accordion-item accordion__item"
							key={index}
							uuid={`testing-details-individuals-${index}`}
						>
							<AccordionItemHeading
								className="typography typography--white typography--h2"
								onClick={handleAccordionChange(index)}
							>
								<AccordionItemButton
									aria-expanded={activeIndex === index ? true : false}
									className="typography typography--white typography--h2 accordion__button accordion__button--white btn btn--transparent"
								>
									{title}
								</AccordionItemButton>
							</AccordionItemHeading>

							<AccordionItemPanel className="accordion__panel">
								<div className="testing-details-individuals__types">
									{tests.map((test, index) => {
										return <TestType key={index} {...test} testsApi={productInfo}/>;
									})}
								</div>
							</AccordionItemPanel>
						</AccordionItem>
					);
				})}
			</Accordion>
		</div>
	) : (
		<div className="testing-details-events">
			<div className="testing-details-events__types">
				{rows.map((acc) => {
					const { tests } = acc;
					return tests.map((test, index) => <TestType key={index} {...test} testsApi={productInfo} />);
				})}
			</div>
		</div>
	);
};

TestingDetailsContent.propTypes = {
	rows: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			tests: PropTypes.arrayOf(
				PropTypes.shape({
					name: PropTypes.string,
					cost: PropTypes.string,
					categories: PropTypes.arrayOf(
						PropTypes.shape({
							name: PropTypes.string,
						})
					),
					processingTime: PropTypes.string,
					longDescription: PropTypes.shape({
						raw: PropTypes.string,
					}),
					cta: PropTypes.shape({
						title: PropTypes.string,
						link: PropTypes.string,
					}),
					method: PropTypes.arrayOf(
						PropTypes.shape({
							name: PropTypes.string,
						})
					),
				})
			),
		})
	).isRequired,
};

export default TestingDetailsContent;
